<template>
  <div class="record">
    <b-table
      show-empty
      hover
      small
      head-variant="dark"
      thead-class="d-none"
      :items="columns_to_check"
      :fields="[{key: 'name'}, {key: 'value'}]">
      <template v-slot:cell(name)="data">
        <span class="text-primary">
          {{ data.value }}
        </span>
      </template>
      <template v-slot:cell(value)="data">
        {{ record[0][data.item.name] }}
      </template>
    </b-table>
  </div>
  <!-- <div class="record">
    <b-table
      show-empty
      hover
      small
      head-variant="dark"
      thead-class="d-none"
      :items="columns_"
      :fields="[{key: 'name'}, {key: 'value'}]">
      <template v-slot:cell(name)="data">
        <span class="text-primary">
          {{ data.value }}
        </span>
      </template>
      <template v-slot:cell(value)="data">
        {{ record[data.value] }}
      </template>
    </b-table>
  </div> -->

  <!-- <div class="record">
    <b-table
      hover
      :items="columns_"
     >
      
    </b-table>
  </div> -->
</template>

<script>
  import {titleCase} from '../Insights/utils';

  export default {
    name: 'Record',

    props: {
      fileType: {
        type: String,
        required: true
      },
      record: {
        type: Object,
        required: true
      }
    },

    computed: {
      column_keys(){
        return this.columns_.map(e =>
          Object.keys(e)
        )
      },
      columns() {
        return this.column_keys.map(col => ({
            name: titleCase(col)
          }));
      },
       columns_(){
          return this.record;
    },
    columns_to_check(){
      const columns_2 = this.column_keys;
      return columns_2[0].map(e=>({name:e}))
      
    }

    }
   
  };
</script>

<style>
  .record .table tbody tr:first-child td {
    border-top: none;
  }
</style>
